import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useCompanyInsight = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [companyInsightData, setCompanyInsightData] = useState<any>(null);

    const onGetCompanyInsightError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while retrieving company insight data.',
        );
    };

    const onGetCompanyInsightSuccess = (callback: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<GetCompanyInsightResponse>) => {
        setCompanyInsightData(data?.records?.[0] ?? null);
        callback();
    };

    const getCompanyInsight = (id: any, callback: () => void) => {
        const url: HttpConfig = {
            // url: `ba/v1/dispatchers/search?query=${ninNumber}`,
            url: `ba/v1/company?search=${id}`,
            method: 'get',
        };

        request(url, onGetCompanyInsightSuccess(callback), setLoading, onGetCompanyInsightError);
    };

    return { getCompanyInsight, loading, companyInsightData };
};

export default useCompanyInsight;


interface CompanyInsightData {
    accountCreatorRole: string;
    availableLookupCount: number;
    createdAt: string;
    email: string;
    fleetSize: string;
    freeLookupCount: number;
    id: string;
    industryType: string;
    isWithinFreeTrial: boolean;
    kycStatus: string;
    name: string;
    phoneNumber: string;
    profilePicture: string | null;
    registrationNumber: string;
    status: string;
    totalAvailableLookupCount: number;
    totalDrivers: number;
    typicalRoute: string;
    updatedAt: string;
    isDeleted: boolean;
}

interface GetCompanyInsightResponse {
    message: string;
    records: CompanyInsightData[];
}
